import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PhotoCardModule } from './photo-card/photo-card.module';
import { PhotoManagementModule } from './photo-management/photo-management.module';

@NgModule({
    imports: [CommonModule],
    exports: [PhotoManagementModule, PhotoCardModule]
})
export class PhotoUploaderModule {}
